import { t } from '@lingui/core/macro';
import { Navigate, useRouteContext, useRouter, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useAuthStore } from 'stores/authStore';
import LoginContainer from './LoginContainer';

const LoginPage = () => {
  const authToken = useAuthStore((state) => state.userToken);
  const router = useRouter();

  const { error_code, redirection_url } = useSearch({ from: '/login' });
  const { redirectUrl } = useRouteContext({ strict: false });

  // SSO Login errors are transmitted by query params

  useEffect(() => {
    if (error_code) {
      if (error_code === 'identity_provider_response_invalid')
        toast.error(
          t`Une erreur est survenue lors de votre connexion, en cas de besoin, vous pouvez contacter le service client Faks.`
        );
      else toast.error(t`Code erreur inconnu : ${error_code}`);
    }
  }, [error_code]);

  useEffect(() => {
    if (redirection_url) {
      router.update({
        context: {
          ...router.options.context,
          redirectUrl: redirection_url,
        },
      });
    }
  }, [redirection_url, router]);

  if (authToken === null) return <LoginContainer />;

  return <Navigate to={redirectUrl || redirection_url || '/'} replace />;
};

export default LoginPage;
